import { render, staticRenderFns } from "./merchantsAudit.vue?vue&type=template&id=00dc29a2&scoped=true"
import script from "./merchantsAudit.vue?vue&type=script&lang=ts"
export * from "./merchantsAudit.vue?vue&type=script&lang=ts"
import style0 from "./merchantsAudit.vue?vue&type=style&index=0&id=00dc29a2&prod&scoped=true&lang=stylus"
import style1 from "./merchantsAudit.vue?vue&type=style&index=1&id=00dc29a2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00dc29a2",
  null
  
)

export default component.exports